<table mat-table class="table" [dataSource]="companies">
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let i">
            {{i.companyName}}
        </td>
    </ng-container>
    <ng-container matColumnDef="currentRole">
        <th mat-header-cell *matHeaderCellDef>Current Role</th>
        <td mat-cell *matCellDef="let i">
            {{i.role === 'Undefined' ? 'None' : i.role}}
        </td>
    </ng-container>
    <ng-container matColumnDef="newRole">
        <th mat-header-cell *matHeaderCellDef>Updated Role</th>
        <td mat-cell *matCellDef="let i">
            <mat-select [(ngModel)]="i.newRole">
                <mat-option value="Undefined">None</mat-option>
                <mat-option value="Standard">Standard</mat-option>
                <mat-option value="Owner">Owner</mat-option>
            </mat-select>
        </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let i; columns: displayedColumns;"></tr>
</table>